<script lang="ts">
    import { deleteTab, type TabClass } from "@store/pageTracker"
    import Popup from "../Popup.svelte"
    import PopupExit from "../PopupExit.svelte"
    import PopupWarning from "../PopupWarning.svelte"
    import { createEventDispatcher } from "svelte"
    import Button from "@components/button/Button.svelte"
    export let tab: TabClass

    const dispatch = createEventDispatcher()
    const finish = () => dispatch("exit")
</script>

<!-- Delete Prompt -->
<Popup on:clickoutside={finish}>
    <PopupExit on:exit={finish} />
    <PopupWarning>
        <span slot="title">
            Do you want to delete “<span class:untitled={!tab.nameWithoutEmoji}
                >{tab.displayName}</span
            >”?
        </span>
        <span slot="paragraph">This cannot be undone.</span>
        <Button color="white" go={finish}>Cancel</Button>
        <Button
            color="danger"
            go={() => {
                deleteTab(tab.id)
                finish()
            }}
        >
            Delete
        </Button>
    </PopupWarning>
</Popup>

<style>
    .untitled {
        font-style: italic;
    }
</style>
